import ReactGA from 'react-ga'


export const sendReactGAEvent = (data: {category: string, action: string}) => {

  if (process.env.NODE_ENV === 'production') {
    ReactGA.event(data)
  }
}
